import React, { useState } from 'react';
import Pagination from 'components/shared/pagination';
import { useFetch } from 'hooks';
import { SavedElementTypes } from 'constants/savedElements';
import { Icon } from 'ui';
import ElementUsage from './ElementUsage';

const ElementUsageRoot = ({ elementId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, initialLoading, error } = useFetch(
    `/content/library/elements/${elementId}/sections?page=${currentPage}`,
  );

  const hasSections = !initialLoading && !error && data.totalSections > 0;

  const notSupported =
    !initialLoading &&
    !error &&
    data.totalSections === 0 &&
    data.savedElementType === SavedElementTypes.Template;

  if (notSupported) {
    return (
      <div className="ff-ss c-gray-darker">
        <Icon name="info" className="c-gray-light mr-8" />
        {t('element_builder.usage.template_element_not_supported')}
      </div>
    );
  }

  return (
    hasSections && (
      <div className="Animated Animated--fadeIn mb-32">
        <ElementUsage
          totalSections={data.totalSections}
          totalLessons={data.totalLessons}
          sections={data.sections}
          pagination={
            data.totalPages > 1 && (
              <Pagination
                className="mt-32"
                pages={data.totalPages}
                pageSelectCallback={setCurrentPage}
                selected={currentPage}
              />
            )
          }
        />
      </div>
    )
  );
};

export default ElementUsageRoot;
